import { createSlice } from '@reduxjs/toolkit';
import { getLocationGroups } from 'ducks/location-groups-list/operators';
import { Slices } from 'ducks/slices';
import { normalizeLookups } from 'ducks/utils';

export type LocationGroupsListState = ReturnType<typeof normalizeLookups<'location_group_name', 'location_group_id'>>;

const initialState: LocationGroupsListState = [];

const locationGroupsListSlice = createSlice({
  name: Slices.LOCATION_GROUPS_LIST,
  initialState,
  reducers: {
    clearLocationGroupsList: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLocationGroups.pending, () => {
        return initialState;
      })
      .addCase(getLocationGroups.fulfilled, (_, { payload }) => {
        return normalizeLookups(payload, 'location_group_name', 'location_group_id');
      })
      .addCase(getLocationGroups.rejected, () => {
        return initialState;
      });
  },
});

export const { clearLocationGroupsList } = locationGroupsListSlice.actions;

export default locationGroupsListSlice.reducer;
